<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes prisoners-1 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #prisoners-1 {
    animation-name: prisoners-1;
  }
  @keyframes prisoners-2 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #prisoners-2 {
    animation-name: prisoners-2;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 801.2 180.8" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="prisoners-2">
      <path
        fill="var(--flesh)"
        d="M801 81c-5 5-9 10-15 14-5 3-9 3-14 3-13-3-26-5-39-4-2 0-5 1-6-2-2-7-8-12-14-17-1-1-2-3-1-5 3-5 2-10-1-16-2-4-2-8-2-13 5-1 9 4 15 3l-7-7-5-9a55 55 0 0 0-3-5 3 3 0 0 0-2-2c-10 0-14 5-9 14v2c-8 0-8 0-9-8 0-2-1-2-3-3-5-3-11-2-16-5a83 83 0 0 1 31-4c4 1 7-1 9-5s5-10 12-8c1 1 2 0 3-1 4-4 9-4 14-2a13 13 0 0 0 6 1 7 7 0 0 1 7 3 14 14 0 0 0 7 5 4 4 0 0 1 3 4c1 2 3 4 2 6-3 8 1 12 7 15l12 7c9 6 12 17 16 27 0 1 0 3 2 4Z"
      />
      <path
        fill="var(--hair)"
        d="m58 127-16 14c-8 10-8 14-2 25l1 2c6 10 5 12-7 13-4 0-8-1-11-4 1-4-2-4-6-4-1-4-3-7-8-8a7 7 0 0 0-3-7l-1-1c4-6 2-11 0-16v-14l1-2v-5l-1-6c2-2 2-3 0-4-3-5-2-12-5-17V80c8-5 16-4 24-3 9 0 17 4 25 8l6 3c-1 3-4 2-6 2-7 0-10 3-11 10-1 10 7 21 16 25l4 2Z"
      />
      <path
        fill="var(--shirt)"
        d="M709 41c0 5 0 9 2 13 3 6 4 11 1 16-1 2 0 4 1 5 6 5 12 10 14 17 1 3 4 2 6 2a22 22 0 0 1 2 4c2 8 0 10-9 11h-15c-17-2-29 8-42 17-15 10-29 23-46 31-9 4-19 5-29 7a57 57 0 0 0-15 4c-6 3-12 4-18 4-23 2-46 0-68-3-6 0-8-3-10-8 0-1 0-3-2-3-4-18-4-37-3-56l-2-8c-1-7-4-14-2-21 3-5 9-7 13-10 2 0 4 0 5 2 1 4 4 5 8 5 6 0 14 1 18-6a3 3 0 0 1 2-1c10-1 19-6 28-8 14-2 25-10 36-18 10-7 19-14 30-18 8-3 16-5 24-4a291 291 0 0 1 32 6c5 4 11 2 16 5 2 1 3 1 3 3 1 8 1 8 9 8l11 4Z"
      />
      <path
        fill="var(--flesh)"
        d="m58 127-4-2c-9-4-17-15-16-25 1-7 4-10 11-10 2 0 5 1 6-2 6-1 10 1 15 2a21 21 0 0 0 7 1c7 3 15 4 22 5 6 1 13 3 19 1a2 2 0 0 0 3 1h36c-11-4-22-8-33-7-9-3-14-9-14-17 0-9 4-13 12-13 2 0 4 1 5-1 10 4 21 5 31 7 20 3 41 3 61 7 8 2 15 6 22 9l25 13c13 5 26 2 38 0l16-5 7 1c1 2-3 4-2 6 0 4-2 5-5 6-7 0-9 5-10 11a57 57 0 0 0-2 13c0 14 4 28 8 42-11 2-21 1-32 0-11-2-21-3-31-2-13 2-24-1-35-6-13-6-28-9-42-11-22-3-43-11-64-17l-8-2a112 112 0 0 0-22-5c-8-1-16-2-24 0Z"
      />
      <path
        fill="var(--pants)"
        d="M316 170c-4-14-8-28-8-42a57 57 0 0 1 2-13c1-5 3-11 10-11 3-1 5-2 5-6-1-2 3-4 2-6 6-5 13-6 20-7a214 214 0 0 1 24-5 74 74 0 0 0 27-8c17-10 35-12 54-9a48 48 0 0 1 22 10c-2 7 1 14 2 21l2 8c-1 19-1 38 3 56a77 77 0 0 0-21 9c-13 8-26 11-41 10l-54-2-43-2-6-3Z"
      />
      <path
        fill="var(--hair)"
        d="M118 97c-6 2-13 0-19-1-7-1-15-2-22-5 2-11 0-21 0-31 0-5-1-10 1-13 4-6 9-1 13-2 14 0 25 7 36 15-1 2-3 1-5 1-8 0-12 4-12 13 0 8 5 14 14 17 0 4-4 4-6 6ZM783 42l-12-7c-6-3-10-7-7-15 1-2-1-4-2-6 2-1 4 1 6 2a44 44 0 0 1 15 23v1Z"
      />
      <path fill="var(--flesh)" d="M783 40v-1 1Z" />
      <path
        fill="var(--hair)"
        d="M82 127a112 112 0 0 1 22 5c0 4 3 8-3 10s-11 0-14-4a40 40 0 0 1-5-11Z"
      />
      <path
        fill="var(--pants)"
        d="M5 141c1 5 4 10 0 16v-16ZM9 165c5 1 7 4 8 8a25 25 0 0 1-8-8ZM17 173c4 0 7 0 6 4a12 12 0 0 1-6-4ZM6 158a7 7 0 0 1 3 7c-2-2-3-4-3-7ZM5 110c2 1 2 2 0 4a4 4 0 0 1 0-4ZM6 120v2ZM6 125v2Z"
      />
      <path
        fill="var(--hair)"
        d="m709 41-11-4v-2c-5-9-1-14 9-13a3 3 0 0 1 2 1 55 55 0 0 1 3 5l5 9 7 7c-6 1-10-4-15-3Z"
      />
    </g>
    <g id="prisoners-1">
      <path
        fill="var(--hair)"
        d="M0 79c10-4 20-4 30-2 9 2 17 6 25 10-1 3-4 2-6 2-7 1-9 3-11 9a22 22 0 0 0 2 12c3 8 10 13 18 16l-15 14c-9 11-10 14-2 26v2c6 9 5 10-6 12a16 16 0 0 1-12-3 78 78 0 0 1-13-11c-6-8-6-17-5-25 2-17-1-33-4-50H0Z"
      />
      <path
        fill="var(--shirt)"
        d="m473 71 8-2c4-2 9-3 11 3 2 4 6 5 10 5 5 1 11 1 15-3l3-2c6 3 11-1 17-2l51-11 31-7c23-3 44-4 64 8a8 8 0 0 0 2 0c3 3 5 6 9 8 3 1 2 4 1 5-2 6 0 10 6 10l10 8c-3 2-2 5-2 8 0 7 0 14-5 20-3 3-1 8 1 9 5 3 4 8 5 12s2 7 6 9c-1 13-2 14-15 11l-19-7h-9c-26 2-50 14-75 19-8 2-16 2-24 0-14-2-27-2-40-1-15 2-30 2-45 2-6 0-9-4-12-8a56 56 0 0 1-3-6c-6-16-6-33-4-50a94 94 0 0 0 0-24c0-5 0-9 3-14Z"
      />
      <path
        fill="var(--flesh)"
        d="M58 126c-8-3-15-8-18-16a22 22 0 0 1-2-12c2-6 4-8 11-9 2 0 5 1 6-2 6 0 12 2 17 3h5l4 2 18 3c6 1 13 3 19 1l3 1c12 2 24 0 36 0a245 245 0 0 0-24-7c-3-1-6-1-9 1l-5-3a18 18 0 0 1-7-23c2-4 4-6 8-5 3 0 5 2 7-1 10 4 20 4 30 7a204 204 0 0 0 33 5l19 1c8 0 17 2 25 7l30 15c11 6 23 5 34 2l27-7h4c-2 3-4 5-4 8 0 5-2 6-6 6-5 1-8 4-9 9a84 84 0 0 0-2 15c0 15 4 29 8 42-13 3-27 1-40-1a93 93 0 0 0-19 0c-16 1-31-3-46-9-10-5-21-7-33-8s-22-5-33-8l-41-12a174 174 0 0 0-22-5c-8-1-16-2-24 0Z"
      />
      <path
        fill="var(--pants)"
        d="M316 169c-4-13-8-27-8-42a84 84 0 0 1 2-15c1-5 4-8 9-9 4 0 6-2 6-6 0-3 2-5 4-8 10-5 21-6 32-8 16-2 31-7 45-14 17-8 36-8 54-3a36 36 0 0 1 13 7c-3 5-4 9-3 14a94 94 0 0 1 0 24c-2 17-2 34 4 50l-17 8c-12 7-24 10-38 9l-95-4a10 10 0 0 1-8-3Z"
      />
      <path
        fill="var(--flesh)"
        d="M701 83c-6 0-8-4-6-10 1-1 2-4-1-5-4-2-6-5-9-8 7 0 14 2 20 3 6 5 11 5 15 1 2-3 7-6 8-5 6 3 12-2 17 1 9 4 18 8 22 19 3 4 3 8 0 13-2 3-1 6 1 9a133 133 0 0 0 12 15c7 10 6 22 7 34a10 10 0 0 1-7 11l-16 6c-3 1-6 0-9-1-11-5-22-12-34-16a12 12 0 0 0-5-1c-4-2-4-5-6-9s1-10-5-12c-2-1-4-6-1-9 5-6 5-13 5-20 0-3-1-6 2-8l12 8h1c-6-8-6-17-8-25 0-1 0-3-2-2-4 1-8-2-12 0l-1 2v9Z"
      />
      <path
        fill="var(--hair)"
        d="M118 96c-6 2-13 0-19-1l-18-3-4-2a81 81 0 0 0 0-23 79 79 0 0 1 0-15c1-8 1-8 10-8 15 0 28 7 40 15-2 3-4 1-7 1-4-1-7 1-8 5a18 18 0 0 0 7 23l5 3c0 3-4 3-6 5ZM780 116a133 133 0 0 1-12-15c-2-3-3-6-1-9 3-5 3-9 0-13 8 6 12 15 13 24a34 34 0 0 1 0 13ZM82 126a174 174 0 0 1 22 5c0 4 3 8-3 10s-11 1-14-4l-5-11Z"
      />
      <path
        fill="var(--hair)"
        d="M701 83v-9l1-2c4-2 8 1 12 0 1-1 2 1 2 2 2 8 2 17 8 25h-1l-12-8Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>